import React, { useContext } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import './CategoryList.css';

const CategoryList = ({ categories, selectedCategory, onSelectCategory }) => {
  const { language } = useContext(LanguageContext);
  const isRTL = language === 'ar';

  if (!categories || categories.length === 0) {
    return (
      <div className="empty-categories">
        {language === 'ar' ? 'لا توجد فئات متاحة' : 'No categories available'}
      </div>
    );
  }

  return (
    <div className={`category-filters ${isRTL ? 'rtl' : ''}`}>
      <div className="category-grid">
        <button
          onClick={() => onSelectCategory(null)}
          className={`category-filter-item ${!selectedCategory ? 'active' : ''}`}
        >
          {language === 'ar' ? 'الكل' : 'All'}
        </button>
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onSelectCategory(category.id)}
            className={`category-filter-item ${selectedCategory === category.id ? 'active' : ''}`}
          >
            {language === 'ar' ? category.name_ar : category.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryList;
